import React from "react";
import { BtnGeneral } from "../../../styles/Buttons";
import { GridComplement, Field, Label, IconButtonGroup } from "../Calculator.style";
import { FaSearch, FaEraser } from "react-icons/fa";

export default function PacienteForm({
  paciente,
  onBuscar,
  onLimpiar,
  calcularEdad
}) {
  return (
    <GridComplement>
      <Field>
        <Label>
          Fecha Nacimiento: {paciente ? paciente.fechaNacimiento : " "}
        </Label>
      </Field>
      <Field>
        <Label>
          Edad: {paciente ? `${calcularEdad(paciente.fechaNacimiento)} años` : " "}
        </Label>
      </Field>
      <Field>
        <Label>Sexo: {paciente ? paciente.sexo : " "}</Label>
      </Field>
      <Field>
        <IconButtonGroup>
          <BtnGeneral bg="blue" onClick={onBuscar} title="Buscar Paciente">
            <FaSearch />&nbsp;Buscar
          </BtnGeneral>
          <BtnGeneral bg="gray" onClick={onLimpiar} title="Limpiar Campos">
            <FaEraser />&nbsp;Limpiar
          </BtnGeneral>
        </IconButtonGroup>
      </Field>
    </GridComplement>
  );
}
